type SearchResultItem {
  id: ID!
  doctype: String!
  created_at: String
  modified_at: String
  owning_user_id: String
  owning_org_id: String
  owning_org_name: String
  regulating_org_id: String
  first_name: String
  last_name: String
  phone_number: [String]
  organisation_name: String
  email: String
  address1: String
  address2: String
  address3: String
  town: String
  postcode: String
  Cases: [SearchResultCase!]
  Properties: [SearchResultProperty!]
}

type SearchResultCase {
  id: ID!
  doctype: String!
  created_at: String
  modified_at: String
  case_status: CaseStatus
  case_reason: MortgageReason
  mortgage_status: MortgageStatus
  term_months: Int
  address1: String
  address2: String
  address3: String
  town: String
  postcode: String
}

type SearchResultProperty {
  id: ID!
  doctype: String!
  created_at: String
  modified_at: String
  address1: String
  address2: String
  address3: String
  town: String
  postcode: String
  country: String
}

type SearchResult {
  total_results: Int
  results: [SearchResultItem!]
  link: String
  bookmark: Int
}

type SearchQuery {
  searchFragment: String!
  bookmark: Int
}
